export var navbarMenu = function navbarMenu() {
  document.querySelectorAll('.js-hamburger-menu').forEach((button) => {
    button.addEventListener('click', () => {
      document.body.classList.toggle('menu-opened');
      document.body.classList.toggle('no-scroll');
      button.classList.toggle('is-active')
      button .setAttribute(
        'aria-expanded',
        button.getAttribute('aria-expanded') === 'false' ? 'true' : 'false'
      );
    });
  });
}
